export default __webpack_public_path__ + "static/media/Bluefish-1.a00b9ced.png";